export default function (number, locale, minimumFractionDigits = 2) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: minimumFractionDigits
  }).format(number);
}